import { rem } from '@Components/styles';
import styled, { css } from 'styled-components';
import IconButton from '@mui/material/IconButton';
import MuiCloseIcon from '@mui/icons-material/Close';

export const MapContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
`;

export const AssetGridWrapper = styled.div<{ show: boolean }>`
	position: absolute;
	height: 50%;
	background: #fff;
	bottom: 0;
	width: 100%;
	z-index: 2;
	transform: translate(0, 100%);
	transition: transform 0.5s;
	${({ show }) =>
		show &&
		css`
			transform: translate(0, 0);
		`}
`;

// Search bar: left 14px + width 312px = right edge 326px. Add 8px gap → 334px.
const SEARCH_BAR_RIGHT_EDGE = 14 + 312;

export const FilterCardOverlay = styled.div<{ searchEnabled?: boolean }>`
	position: absolute;
	top: ${rem(8)};
	left: ${({ searchEnabled }) =>
		rem(searchEnabled ? SEARCH_BAR_RIGHT_EDGE + 8 : 8)};
	z-index: 5;
`;

export const GeocoderCloseIcon = styled(MuiCloseIcon)`
	width: 1em;
	height: 1em;
`;

export const GeocoderCloseButton = styled(IconButton).attrs({ size: 'small' })`
	float: right;
`;

export const GeocoderAddressInfo = styled.div`
	font-size: ${rem(14)};
`;

export const GeocoderPlaceName = styled.div`
	margin-bottom: ${rem(10)};
`;

export const GeocoderCoords = styled.div`
	font-size: ${rem(12)};
`;

export const GridToggleButton = styled.button<{ active: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	background: #fff;
	border: none;
	border-radius: 4px;
	box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	color: ${({ active }) => (active ? '#0066cc' : '#333')};

	&:hover {
		background: #f0f0f0;
	}

	svg {
		font-size: 20px;
	}
`;
